import {gql} from "@apollo/client";

export const getNotifications = gql`
  query getNotifications {
    notifications {
      id
      time
      read
      readableMessage
      client{ id, avatar, fullName}
    }
  }
`

// export const getClientEvents = gql`
//   query getClientEvents($clientId: ID!) {
//     events(clientId: $clientId) {
//       id
//       readableMessage
//       date
//       client{ avatar, fullName}
//     }
//   }
// `

export const markNotificationAsReadMutation = gql`
  mutation markNotificationAsRead($id: ID!) {
    markNotificationRead( input: { id: $id }) {
      notifications {
        id
      }
    }
  }
`

